export const ActionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
    ADD_TO_CART: "ADD_TO_CART",
    DECREASE_CART_QUANTITY: "DECREASE_CART_QUANTITY",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
};
